import React from "react";

export const t = (strings: TemplateStringsArray | string | { message: string; [key: string]: any }, ...values: any[]) => {
  if (typeof strings === "string") return strings;
  if (typeof strings === "object" && "message" in strings) return strings.message;
  return String.raw({ raw: strings as TemplateStringsArray }, ...values);
};

export const msg = t;

export type TransProps = any;
export const Trans = (props: TransProps) => <>{props.children || props.defaults || props.message || props.id}</>;

export const Plural = ({ value, one, other }: { value: number; one: string; other: string }) => {
  return <>{value === 1 ? one : other}</>;
};

export const plural = (value: number, options: { one: string; other: string }) => {
  return value === 1 ? options.one : options.other;
};

// Mock i18n object if needed, though we try to remove usage
export const i18n = {
  _: (id: string) => id,
  load: () => {},
  activate: () => {},
  locale: "en",
};

export const useLingui = () => ({ i18n });
